import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCatalog = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_113_10699)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_113_10699",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_113_10699)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M4.50777 20.119C4.05761 20.119 3.67711 19.9636 3.36627 19.6528C3.05544 19.342 2.90002 18.9615 2.90002 18.5113V7.12679C2.90002 6.67663 3.05544 6.29613 3.36627 5.98529C3.67711 5.67446 4.05761 5.51904 4.50777 5.51904H19.4923C19.9424 5.51904 20.3229 5.67446 20.6338 5.98529C20.9446 6.29613 21.1 6.67663 21.1 7.12679V11.6768H19.8V7.12679C19.8 7.04979 19.7679 6.97929 19.7038 6.91529C19.6398 6.85113 19.5693 6.81904 19.4923 6.81904H12.65V11.6768H11.35V6.81904H4.50777C4.43077 6.81904 4.36027 6.85113 4.29627 6.91529C4.23211 6.97929 4.20002 7.04979 4.20002 7.12679V18.5113C4.20002 18.5883 4.23211 18.6588 4.29627 18.7228C4.36027 18.787 4.43077 18.819 4.50777 18.819H11.05V20.119H4.50777ZM14.75 21.319C14.4872 21.319 14.2632 21.2264 14.078 21.041C13.8927 20.8559 13.8 20.6319 13.8 20.369V17.444H15.1V20.019H19.2V17.444H20.5V20.369C20.5 20.6319 20.4074 20.8559 20.222 21.041C20.0369 21.2264 19.8129 21.319 19.55 21.319H14.75ZM13.55 17.969C13.2807 17.969 13.0649 17.8536 12.9028 17.6228C12.7406 17.3921 12.6865 17.1319 12.7405 16.842L13.1905 14.442C13.2212 14.2165 13.3264 14.0313 13.506 13.8863C13.6859 13.7415 13.8922 13.669 14.125 13.669H20.175C20.4079 13.669 20.6141 13.7415 20.7938 13.8863C20.9736 14.0313 21.0789 14.2165 21.1095 14.442L21.5595 16.842C21.6134 17.0985 21.5593 17.3505 21.3973 17.5978C21.2351 17.8453 21.0194 17.969 20.75 17.969H13.55ZM14.0923 16.669H20.2078L19.8865 14.969H14.4135L14.0923 16.669ZM5.59227 16.769H9.95777V15.469H5.59227V16.769ZM5.59227 13.469H9.95777V12.169H5.59227V13.469ZM5.59227 10.169H9.95777V8.86904H5.59227V10.169ZM13.8923 10.169V8.86904H18.2578V10.169H13.8923Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_113_10699",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgCatalog;
